import router from '../../router'
import axios from 'axios'
import appendHeaders from '../../utils/appendHeaders'
import handleUserNotLogged from '@utils/handleUserNotLogged'

const actions = {
  async getAllReports ({ commit, dispatch, rootGetters }, { pagination } = { pagination: 1 }) {
    commit('REPORT_LIST_FETCHING')
    const formData = new FormData()
    formData.append('page', pagination)
    const { LIST_REPORT: url } = rootGetters['endpoints/endpoints']

    try {
      const { data, status } = await axios({
        method: 'post',
        data: formData,
        url,
        headers: appendHeaders(),
        withCredentials: true,
        validateStatus: () => true,
      })

      const { code, errors } = data

      if (code !== 'OK' && errors) {
        const issue = { ...data, status }
        throw issue
      }
      const {
        data: { reports, ...pagination },
      } = data
      commit('REPORT_LIST_SUCCESS', { reports, pagination })
      return data
    } catch (error) {
      commit('REPORT_LIST_ERROR', error)
      handleUserNotLogged(error)(dispatch)
    }
  },
  async showReport ({ commit, dispatch, rootGetters }, payload) {
    commit('REPORT_SHOW_FETCHING')
    const { SHOW_REPORT: url } = rootGetters['endpoints/endpoints']

    const formData = Object.keys(payload).reduce((acc, item) => {
      acc.append(item, payload[item])
      return acc
    }, new FormData())

    try {
      const { data, status } = await axios({
        method: 'post',
        data: formData,
        url,
        headers: appendHeaders(),
        withCredentials: true,
        validateStatus: () => true,
      })

      const { code, errors } = data

      if (code !== 'OK' && errors) {
        const issue = { ...data, status }
        throw issue
      }
      const {
        data: { report },
      } = data
      commit('REPORT_SHOW_SUCCESS', report)
      return data
    } catch (error) {
      commit('REPORT_SHOW_ERROR', error)
      handleUserNotLogged(error)(dispatch)
    }
  },
  async createReport ({ commit, dispatch, rootGetters }, payload) {
    commit('REPORT_CREATE_FETCHING')
    const { CREATE_REPORT: url } = rootGetters['endpoints/endpoints']

    const formData = Object.keys(payload).reduce((acc, item) => {
      acc.append(item, payload[item])
      return acc
    }, new FormData())

    try {
      const { data, status } = await axios({
        method: 'post',
        data: formData,
        url,
        headers: appendHeaders(),
        withCredentials: true,
        validateStatus: () => true,
      })

      const { code, errors } = data

      if (code !== 'OK' && errors) {
        const issue = { ...data, status }
        throw issue
      }
      const {
        data: reportCurrent,
      } = data

      const { wallet_address: walletAddress } = reportCurrent
      commit('REPORT_CREATE_SUCCESS', reportCurrent)

      dispatch('getAllReports')
      router.push({
        name: 'verification',
        params: { walletAddress },
      })
      return data
    } catch (error) {
      commit('REPORT_CREATE_ERROR', error)
      handleUserNotLogged(error)(dispatch)
    }
  },
  async upgradeReport ({ commit, dispatch, rootGetters }, payload) {
    commit('REPORT_UPGRADE_FETCHING')
    const { UPGRADE_REPORT: url } = rootGetters['endpoints/endpoints']

    const formData = Object.keys(payload).reduce((acc, item) => {
      acc.append(item, payload[item])
      return acc
    }, new FormData())

    try {
      const { data, status } = await axios({
        method: 'post',
        data: formData,
        url,
        headers: appendHeaders(),
        withCredentials: true,
        validateStatus: () => true,
      })

      const { code, errors } = data

      if (code !== 'OK' && errors) {
        const issue = { ...data, status }
        throw issue
      }
      const { data: report } = data
      commit('REPORT_UPGRADE_SUCCESS', report)
      dispatch('getAllReports')
      dispatch('auth/userShow', null, { root: true })
      return data
    } catch (error) {
      commit('REPORT_UPGRADE_ERROR', error)
      handleUserNotLogged(error)(dispatch)
    }
  },
  selectReport ({ commit }, report) {
    commit('REPORT_SELECTED', report)
  },
  async deleteReport ({ commit, dispatch, rootGetters }, payload) {
    commit('REPORT_DELETE_FETCHING')
    const { DELETE_REPORT: url } = rootGetters['endpoints/endpoints']

    const formData = Object.keys(payload).reduce((acc, item) => {
      acc.append(item, payload[item])
      return acc
    }, new FormData())

    try {
      const { data, status } = await axios({
        method: 'post',
        data: formData,
        url,
        headers: appendHeaders(),
        withCredentials: true,
        validateStatus: () => true,
      })

      const { code, errors } = data

      if (code !== 'OK' && errors) {
        const issue = { ...data, status }
        throw issue
      }
      const { data: report } = data
      commit('REPORT_DELETE_SUCCESS', report)
      dispatch('getAllReports')
      return data
    } catch (error) {
      commit('REPORT_DELETE_ERROR', error)
      handleUserNotLogged(error)(dispatch)
    }
  },
}

const mutations = {
  REPORT_LIST_FETCHING (state) {
    state.fetching = true
  },
  REPORT_LIST_SUCCESS (state, { reports, pagination }) {
    state.fetching = false
    state.hasFetched = true
    state.reports = [...reports]
    state.reportsPagination = { ...pagination }
  },
  REPORT_LIST_ERROR (state, error) {
    state.fetching = false
    state.hasFetched = true
    state.error = { ...error }
  },
  REPORT_SELECTED (state, report) {
    state.current = { ...report }
  },
  REPORT_SHOW_FETCHING (state) {
    state.fetching = true
  },
  REPORT_SHOW_SUCCESS (state, report) {
    state.fetching = false
    state.current = { ...report }
  },
  REPORT_SHOW_ERROR (state, error) {
    state.fetching = false
    state.error = { ...error }
  },
  REPORT_CREATE_FETCHING (state) {
    state.fetching = true
  },
  REPORT_CREATE_SUCCESS (state, report) {
    state.fetching = false
    state.current = { ...report }
  },
  REPORT_CREATE_ERROR (state, error) {
    state.fetching = false
    state.error = { ...error }
  },
  REPORT_UPGRADE_FETCHING (state) {
    state.fetching = true
  },
  REPORT_UPGRADE_SUCCESS (state, report) {
    state.fetching = false
    state.current = { ...report }
  },
  REPORT_UPGRADE_ERROR (state, error) {
    state.fetching = false
    state.error = { ...error }
  },
  REPORT_DELETE_FETCHING (state) {
    state.fetching = true
  },
  REPORT_DELETE_SUCCESS (state) {
    state.fetching = false
  },
  REPORT_DELETE_ERROR (state, error) {
    state.fetching = false
    state.error = { ...error }
  },
}

const state = {
  fetching: false,
  hasFetched: false,
  error: null,
  reports: [],
  reportsPagination: {
    page: 1,
    pages: 1,
  },
  current: null,
}
const getters = {
  hasFetched: (state) => state.hasFetched,
  fetching: (state) => state.fetching,
  reports: (state) => state.reports,
  error: state => state.error,
  currentReport: (state) => state.current,
  currentReportAddressWallet: (state) => state.current && state.current.wallet_address,
  getReportByAddressWallet: (state) => (address) =>
    state.reports.find((report) => report.wallet_address === address),
  hasBoughtReport: (state) => state.current.type === 'full',
  reportsDashboard: (state) =>
    [...state.reports].reverse().filter((_, i) => i < 5),
  totalElements: state => state.reportsPagination && state.reportsPagination.records,
  page: state => state.reportsPagination && state.reportsPagination.page,
  pages: state => state.reportsPagination && state.reportsPagination.pages,
  elementsPerPage: state => state.reportsPagination && state.reportsPagination.elements,
}

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
}
